export class DailySnapshotData {
    'startedAt';
    'count';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return DailySnapshotData.attributeTypeMap;
    }
    constructor() {
    }
}
